import { AES, enc } from 'crypto-js'
const SECRET_KEY = process.env.GATSBY_SECRET_KEY

export const encrypt = (uncryptedData) => AES.encrypt(JSON.stringify(uncryptedData), SECRET_KEY).toString()

export const decrypt = (encryptedData) => JSON.parse(AES.decrypt(encryptedData, SECRET_KEY).toString(enc.Utf8))